"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var Search = function Search() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.02916 9.96741C5.02916 6.6878 7.6878 4.02916 10.9674 4.02916C14.247 4.02916 16.9057 6.6878 16.9057 9.96741C16.9057 11.582 16.2613 13.046 15.2157 14.1165C15.1973 14.1305 15.1796 14.1459 15.1627 14.1627C15.1459 14.1796 15.1305 14.1973 15.1165 14.2157C14.046 15.2613 12.582 15.9057 10.9674 15.9057C7.6878 15.9057 5.02916 13.247 5.02916 9.96741ZM15.5169 15.2446C14.2962 16.2979 12.7062 16.9348 10.9674 16.9348C7.11942 16.9348 4 13.8154 4 9.96741C4 6.11942 7.11942 3 10.9674 3C14.8154 3 17.9348 6.11942 17.9348 9.96741C17.9348 11.7062 17.2979 13.2962 16.2446 14.5169L21.8493 20.1216C22.0503 20.3225 22.0503 20.6483 21.8493 20.8493C21.6483 21.0503 21.3225 21.0503 21.1216 20.8493L15.5169 15.2446Z"
    })
  });
};
exports.Search = Search;